import React, { useContext, useState } from 'react';
import { AnalyticsDashboardView } from './AnalyticsDashboard.view';
import { AnalyticsContext } from '../AnalyticsProvider';

export enum AnalyticsVisualizationType {
  'profile' = 1,
  'overview'
}
export enum DashboardTab {
  'engagement' = 1,
  'overview',
  'category'
}

export const AnalyticsDashboardController = () => {
  const { socialProfiles, setView, view } = useContext(AnalyticsContext);
  const [activeTab, setActiveTab] = useState<DashboardTab>(DashboardTab.overview);

  const props = {
    view: view ?? AnalyticsVisualizationType.overview,
    setView,
    activeTab,
    setActiveTab,
    socialProfiles
  };
  return <AnalyticsDashboardView {...props}></AnalyticsDashboardView>;
};
